import React, { useEffect, useState } from 'react';
import { translate } from '../services/translate';
import { companyService } from '../services/central-api/company';
import FormDropDownPicker from './FormDropDownPicker';
import { UseFormReturn } from 'react-hook-form';
import { StyleProp, TextStyle } from 'react-native';
import FilterDropdown from './Filter/components/FilterDropdown';


type Props = {
    zIndex: number;
    disabled?: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    required?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function CompanyDropdown({ form, fieldName, zIndex, disabled, labelStyle, required, viewStyle, value, setValue }: Props) {
    const [selectableCompanies, setSelectableCompanies] = useState<{ label: string; value: number; }[]>([]);

    async function getCompanies() {
        try {
            const companies = await companyService.getSimplifiedCompanies();
            setSelectableCompanies(companies.map((company) => {
                return {
                    value: company.id,
                    label: company.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getCompanies();
    }, []);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('company')}
            items={selectableCompanies}
            zIndex={zIndex}
            multiple={false}
            disabled={disabled}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            required={required}
            fieldName={fieldName}
            form={form}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('company')}
                items={selectableCompanies}
                zIndex={zIndex}
                multiple={false}
                disabled={disabled}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
                required={required}
                setValue={setValue}
                value={value}
            />
        );
    }

}

export default CompanyDropdown;
